import React from 'react';
import {
    PRODUCT_NAME,
    COMPANY_LEGAL_NAME,
    PRODUCT_SUPPORT_EMAIL,
    PRODUCT_WEBSITE,
    PRODUCT_PLATFORM
} from '../constants/constants';

const PrivacyPolicy_en = () => {
    return (

        <>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                <div style={{ width: '90%' }}>
                    <p>

                    </p>
                    <p>
                        <strong>PRIVACY POLICY</strong>
                    </p>
                    <p>
                    </p>
                    <p>
                        The Nashville Public Library Foundation, a Tennessee nonprofit corporation. (“NPLF,” “We,” “Us,” or “Our”), is committed to ensuring the privacy and security of you (“User,” “You,” or “Your”), and Your access to and use of the Begin Bright program, including any and all content, functionality, and services offered on or through the platform available at <a href="http://platform.beginbright.org">platform.beginbright.org</a> (the “Platform”). NPLF and User may be referred to in the singular as a “Party” and collectively as the “Parties.”
                    </p>
                    <p>
                    </p>
                    <p>
                        NPLF is committed to safeguarding the privacy of the User and its data, information, and other personally identifying information through Our compliance with this policy (the “Privacy Policy”). This Privacy Policy, available at platform.beginbright.org/privacy, informs the User of the types of information We may collect from You or that You may provide when You access or use the Platform. Moreover, This Privacy Policy details Our practices for collecting, using, maintaining, retaining, protecting, and disclosing Your data and information, including Your Personal Data (as defined herein).
                    </p>
                    <p>
                    </p>
                    <p>
                        Please read this Privacy Policy carefully, thoroughly, and completely to understand Our policies and practices regarding Your data, information, and other personally identifying information, and how We collect, use, maintain, protect, and disclose the foregoing. If You do not agree with the terms of the Privacy Policy, You may use the Platform. By accessing, visiting, or using Our Platform, You agree to the terms of this Privacy Policy in its entirety.
                    </p>
                    <p>
                    </p>
                    <p>
                        This Privacy Policy may change from time to time (“Changes”). Your continued use of or access to the Platform after NPLF makes Changes is deemed to be an acceptance of those changes; therefore, please routinely monitor this Privacy Policy for any updates, revisions, modifications, or amendments. We will notify the User of any Changes by providing access to the new Privacy Policy on the Platform. NPLF may notify the User via email or by a prominent notice on the Platform, prior to or contemporaneous with the Changes becoming effective, and NPLF will update the date at the bottom of this Privacy Policy (the “Effective Date”). If Our practices change regarding previously collected Personal Data (as defined herein) in a way that would be materially less restrictive than those policies in effect at the time We collected the information, NPLF will make reasonable efforts to provide notice and to obtain consent to any such uses as may be required by law.
                    </p>
                    <p>
                    </p>

                    <strong>I. Definitions.</strong>

                    <p>
                    </p>
                    <ol>
                        a.  “<strong>Affiliate</strong>” means any Person (as defined herein), other than the Parties, that, directly or indirectly, controls, is controlled by, or is under common control with a Party.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        b.  “<strong>Cookie</strong>” means a message, or segment of data, containing information about a User, sent by a web server to a browser and sent back to the server each time the browser requests a web page. This message, or segment of data, is stored on the User’s Device (as defined herein).
                    </ol>
                    <p>
                    </p>
                    <ol>
                        c.  “<strong>Data Controller</strong>” means the natural or legal person, alone or jointly with others, who determines the purposes and means of the processing of Personal Data (as defined herein). For the purpose of this Privacy Policy, NPLF is the Data Controller of Your information and data, including the Personal Data (as defined herein).
                    </ol>
                    <p>
                    </p>
                    <ol>
                        d.  “<strong>Data Processor</strong>” means any natural or legal Person, public authority, agency, or other body which processes Your information and data, including Personal Data (as defined herein) on behalf of the Data Controller.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        e.  “<strong>Data Subject</strong>” means any identified or identifiable natural or legal Person who is using or accessing the Platform. For the purpose of this Privacy Policy, the Data Subject is the User.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        f.  “<strong>Device</strong>” means any unit of physical hardware or equipment that provides one or more computing functions within a computer system including, but not limited to, desktop computers, laptop (or otherwise portable) computers, mobile/cellular phones, tablets, and other computers capable of using or accessing the Platform.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        g.  “<strong>Person</strong>” means any individual, corporation, partnership, joint venture, limited liability company, governmental authority, unincorporated organization, trust, association, or other entity.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        h.  “<strong>Personal Data</strong>” means any information that can be used to distinguish or trace an individual User’s identity, either alone or when combined with other personal or identifying information, that is linked or linkable to a specific individual.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        i.  “<strong>Processing</strong>” means any operation or set of operations which is performed on data or on sets of data, whether or not by automated means, such as collection, recording, organization, structuring, storage, adaptation or alteration, retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making available, alignment or combination, restriction, erasure, or destruction.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        j.  “<strong>Usage Data</strong>” means certain data that is generated by use of Our Platform, either by an individual User or from general use of the system underlying the Platform.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        k.  “<strong>Web Log</strong>” means a file automatically created and maintained by a web server, containing information on who or what visits, accesses, or uses the Platform, the point of origination for those visiting, accessing, or using the Platform, and the activities and behavior of those visiting, accessing, or using the Platform.
                    </ol>
                    <p>
                    </p>



                    <strong>II. Opt-Out Policy</strong>
                    <p>
                    </p>
                    <ol>

                        a.    <strong>Opt-Out.</strong> From time to time, User acknowledges that User may receive newsletters, updates, marketing or promotional materials, and other communications, which NPLF, in its sole and absolute discretion, deems would be of interest to the User. User may expressly opt out of receiving any, or all, of these communications from NPLF by accessing a web link to unsubscribe, or alternatively, notifying NPLF in accordance with the section titled “<strong>Comments, Concerns, and Complaints</strong>.” You may be able to opt out of receiving personalized advertisements from advertisers and/or advertising networks who are members or subscribers of the following: (i) the Network Advertising Initiative (NAI) and (ii) the Digital Advertising Alliance’s (DAA) Self-Regulatory Principles for Online Behavioral Advertising. To learn more about your choices for opting out of personalized advertising, please visit:
                    </ol>
                    <p>
                    </p>
                    <ol>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        i.  Network Advertising Initiative (NAI) – United States
                        <ol style={{ paddingLeft: 70 }}>
                            <li>
                                Browser Opt-Out: <a href="http://www.networkadvertising.org/choices">http://www.networkadvertising.org/choices</a>
                            </li>
                        </ol>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        ii.      Digital Advertising Alliance (DAA) – United States
                        <ol style={{ paddingLeft: 70 }}>
                            <li>
                                Browser Opt-Out: <a href="http://www.aboutads.info/choices">http://www.aboutads.info/choices</a>
                            </li>
                            <li>
                                Mobile Application-Based Opt-Out: <a href="https://youradchoices.com/appchoices">https://youradchoices.com/appchoices</a>
                            </li>
                        </ol>
                    </ol>
                    <p>
                    </p>


                    <strong>III. Minimum Age; Children’s Privacy.</strong>
                    <p>
                    </p>
                    <ol>
                        a.          <strong>Children’s Online Privacy Protection.</strong> The Platform is not directed to Users under the age of thirteen (13). NPLF does not intend to collect, nor does it knowingly collect, Personal Data from anyone under the age of thirteen (13). No User under the age of thirteen (13) may provide any Personal Data to NPLF or on the Platform.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        b.        <strong>Notification.</strong> If We learn (or are informed) We have collected or received Personal Data from any User under thirteen (13) years of age, without verification or parental consent, We will delete the Personal Data. If You have knowledge or awareness, or alternatively suspect or believe, that NPLF might have any information, including Personal Data, about any User under the age of thirteen (13), please reference the section titled “<strong>Comments, Concerns, and Complaints</strong>,” for the purpose of informing NPLF regarding NPLF’s collection or receipt of Personal Data from any individual under the age of thirteen (13).
                    </ol>
                    <p>
                    </p>


                    <strong>IV. Processing of Information & Data.</strong>
                    <p>
                    </p>
                    <ol>
                        a.    <strong>Collection on Platform.</strong> In order to register for an account with NPLF to use and access the Platform, or to otherwise facilitate the User’s ongoing use of and access of the Platform, the User will be required to provide information and data, including Personal Data. Specifically, NPLF may collect, on the Platform, the following items of information:
                    </ol>
                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li>
                            Personal Data, including (but not limited to):
                            <ol>
                                <li>
                                    name (first and last);
                                </li>
                                <li>
                                    email address;
                                </li>
                                <li>
                                    phone number;
                                </li>
                                <li>
                                    unique identifying information, such as login credentials; and
                                </li>
                                <li>
                                    organization, educational institution or district with which the User is employed or affiliated.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Usage Data
                        </li>
                    </ol>
                    <ol>

                        b.      <strong>Collection on Platform.</strong> Generally, We do not collect information and data about Users of the Platform. NPLF, however, may collect the following information and data about Users:
                    </ol>
                    <p>
                    </p>
                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li >
                            Personal Data that the User voluntarily provides on the Platform (e.g., “<strong>Contact Us</strong>” page) including, but not limited to:
                            <ol >
                                <li>
                                    name (first and last);
                                </li>
                                <li>
                                    email address;
                                </li>
                                <li>
                                    title; and
                                </li>
                                <li>
                                    organization, educational institution or district with which the User is employed or affiliated.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Other User information, such as a User’s:
                            <ol>
                                <li>
                                    requests for material, information, or services; and
                                </li>
                                <li>
                                    reports of problems, issues, or errors with the Platform.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Cookies;
                        </li>
                        <li>
                            Usage Data;
                        </li>
                        <li>
                            Web Logs, consisting of the following:
                            <ol>
                                <li>
                                    the Internet domain from which You access the Platform;
                                </li>
                                <li>
                                    Your Internet Protocol (IP) address;
                                </li>
                                <li>
                                    Your Internet Service Provider (ISP) utilized to use and access the Platform;
                                </li>
                                <li>
                                    the type of web browser and operating system employed by User;
                                </li>
                                <li>
                                    the date and time User accessed, used, or visited the Platform, including the average time expended by the User; and
                                </li>
                                <li>
                                    the webpages accessed, used, or visited on the Platform.
                                </li>
                            </ol>
                        </li>
                    </ol>
                    <p>
                    </p>
                    <ol>
                        c.      <strong>Automatic Collection.</strong> As You navigate through and interact with the Platform, We may use automatic data collection technologies, such as Cookies, to collect certain information about Your equipment, browsing actions, and patterns, including:
                    </ol>
                    <p>
                    </p>
                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li>
                            details of Your visits to the Platform, including traffic data, location data, logs, and other communication data, as well as the contents and resources that You access and use on the Platform;
                        </li>
                        <li>
                            information about Your Device and internet connection, including Your IP address, Internet service provider (ISP), operating system, and browser type; and
                        </li>
                        <li>
                            location information, such as the User’s approximate or actual geographical location.
                        </li>
                    </ol>
                    <p>
                    </p>
                    <ol>
                        d.      <strong>Retention.</strong> NPLF will retain Your information, including Personal Data, only for as long as User uses or accesses the Platform and as necessary for the purposes set out in this Privacy Policy. In addition, We will retain Your information, including Personal Data, to the extent necessary to comply with Our legal obligations, to resolve disputes, and to enforce Our legal agreements and policies.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        e.      <strong>Use.</strong> Generally, We do not use or exploit information and data, including Personal Data, of Users to this Platform. We use Your information and data, including Your Personal Data and Usage Data:
                    </ol>
                    <p>
                    </p>
                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li>
                            to present the Platform and its contents, resources, and services to You;
                        </li>
                        <li>
                            to maintain the Platform, and to improve the navigation, functionality, and operability of the Platform;
                        </li>
                        <li>
                            to contact You with newsletters or promotional, advertising, or marketing materials;
                        </li>
                        <li>
                            to contact You regarding Changes to the Privacy Policy;
                        </li>
                        <li>
                            to provide You with information, contents, resources, products, and services that You may request from NPLF;
                        </li>
                        <li>
                            to deliver support to the User in connection with the Platform;
                        </li>
                        <li>
                            if applicable, to carry out Our obligations and enforce Our rights arising from any contracts entered into between You and NPLF;
                        </li>
                        <li>
                            to monitor, observe, or examine the use of or access to the Platform;
                        </li>
                        <li>
                            to detect, prevent, and address technical, technological, or service errors and issues;
                        </li>
                        <li>
                            to enable You to engage in, participate in, utilize, or activate the interactive features on the Platform; and/or
                        </li>
                        <li>
                            in any other method or fashion as We may so specify upon Your provision of said information, including Your Personal Data.
                        </li>
                    </ol>
                    <p>
                    </p>
                    <ol>
                        f.      <strong>Transfer.</strong> Your information, including Personal Data, is transferred to and maintained on Devices or servers located within the United States. Your information, including Personal Data, may be transferred to, and maintained on, Devices located outside of Your state, province, country, or other governmental jurisdiction where the data protection laws may differ from those of Your jurisdiction. Your consent to this Privacy Policy, followed by Your submission of such information, including Personal Data, represents Your agreement to that transfer. NPLF shall take reasonable measures to ensure that Your data is treated securely and in accordance with this Privacy Policy, and that no transfer of Your Personal Data to a third-party organization or a country shall occur, unless there are adequate controls in place regarding the privacy of Your information, including Personal Data, and the information security protocol. If You are located outside of the United States, please be advised that any information, including Personal Data, You provide to us will be transferred to and within the United States. By using, accessing, or visiting Our Platform, You consent to this transfer.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        g.      <strong>Disclosure.</strong> Generally, We do not disclose, release, sell, or trade information and data, including Personal Data, of Users to third-party Persons. And, we generally do not share information and data, including Your Personal Data, with third-party advertisers unless You give NPLF specific permission. With the foregoing in consideration, We may disclose your information and data, including Your Personal Data, to:
                        <ol type='i' style={{ paddingLeft: 70 }}>
                            <li>
                                Our subsidiaries, affiliates, successors, and assignees;
                            </li>
                            <li>
                                Third parties for the purpose of generating reports for teacher organizations, schools, community centers, and care centers to demonstrate user engagement, program completion, and other relevant metrics.
                            </li>
                            <li>
                                Contractors, Service Providers (as defined herein), external vendors, and other third-party Persons We engage to support Our business model and Platform, and who are bound by contractual obligations to keep Your information, including Personal Data, confidential and proprietary, and to use Your information, including Personal Data, only for the purposes and grounds upon which We disclose;
                            </li>
                            <li>
                                A buyer or any successor in interest in the event of a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of NPLF’s assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which information and data, including Personal Data, held by NPLF about Our Users is among the assets transferred;
                            </li>
                            <li>
                                Fulfill the purpose for which You provide such information;
                            </li>
                            <li>
                                Comply with any court order, law, or legal process, including to respond to any government or regulatory request;
                            </li>
                            <li>
                                Other parties, in NPLF’s sole and absolute discretion, when such disclosure is necessary or appropriate to protect the rights, property, or safety of NPLF, Users, any third parties with which We contract or engage, or others, including the exchange of information with other entities for the purposes of fraud protection and credit-risk reduction;
                            </li>
                            <li>
                                Protect and maintain the security, operability, viability, functionality, and reliability of the Platform;
                            </li>
                            <li>
                                Prevent or investigate potential, threatened, imminent, or actual wrongdoing in connection with the Platform; and
                            </li>
                            <li>
                                Address other needs, contingent upon Your consent.
                            </li>
                        </ol>
                    </ol>
                    <p>
                    </p>
                    <ol>
                        h.      <strong>Facilitation. </strong>We may employ third-party entities, individuals, contractors, and/or subcontractors (“<strong>Service Providers</strong>”) to facilitate the Platform, provide the Platform on Our behalf, perform Platform-related services, or assist NPLF in analyzing how Our Platform and its content, resources, and services are used or accessed. These Service Providers may use, access, or disclose Your information, including Personal Data, for the purpose of performing facilitative services. NPLF utilizes the following Service Providers:
                    </ol>
                    <p>
                    </p>
                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li>
                            Google Analytics, for the purpose of measuring data and information related to traffic, behavior, and conversion, and whose privacy policy is available at https://policies.google.com/privacy and whose information, contents, and materials on cookie usage and other tracking technologies is available at <a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage</a>.
                        </li>
                    </ol>
                    <p>
                    </p>
                    <ol>
                        i.      <strong>Aggregation and Anonymization.</strong> “<strong>Aggregation</strong>” of data and information is generally defined as any process in which information and data is gathered and expressed in summary form. “<strong>Anonymization</strong>” is defined as the process of removing personally identifiable information (e.g., Personal Data) from data sets, so that the corresponding individuals remain anonymous from identification. NPLF, in its sole and absolute discretion and without notice, may aggregate and anonymize Personal Data so that the end-product does not personally identify You or any other User of the Platform.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        j.      <strong>Monitoring.</strong> To ensure the privacy and security of Users of the Platform (as well as third-party Persons), NPLF may monitor Your use of or access to the Platform. We monitor the use of or access to the Platform for the following reasons:
                        <ol type='i' style={{ paddingLeft: 70 }}>
                            <li>
                                to identify fraudulent activities and transactions;
                            </li>
                            <li>
                                to prevent or investigate the potential, threatened, imminent, or actual harm or abuse to Users or third-party Persons, as well as to prevent the potential, threatened, imminent, or actual misuse or exploitation of the Platform;
                            </li>
                            <li>
                                to ensure compliance with and enforce this Privacy Policy;
                            </li>
                            <li>
                                to investigate potential, threatened, imminent, or actual violations of this Privacy Policy; and
                            </li>
                            <li>
                                to protect the rights and property of Users, NPLF, and its Service Providers, contractors, subcontractors, vendors, partners, clients, customers, and other third-party Persons.
                            </li>
                        </ol>
                    </ol>
                    <p>
                    </p>
                    V.        <strong>Access, Correction, Cancellation, and Deletion</strong>
                    <p>
                    </p>
                    <ol type='a' style={{ paddingLeft: 70 }}>
                        <li>
                            <strong>Requests</strong>. Requests to access, correct, or delete personal information and data, including Your Personal Data, must be submitted through reference to the section titled “<strong>Comments, Concerns, and Complaints</strong>.” Please note that We may not be able to delete, correct, or revise Your information and data, including Your Personal Data, where NPLF is legally required to retain and maintain such information and data.
                        </li>
                    </ol>
                    <p>
                    </p>
                    VI.  <strong>Information Security</strong>
                    <p>
                    </p>
                    <ol >

                        a.      <strong>Protective Measures.</strong> We have implemented physical, administrative, and technical measures designed to secure and protect Your information and data, including Personal Data, from accidental loss and from unauthorized access, use, alteration, and disclosure.

                    </ol>

                    <ol>

                        b.       <strong>User Responsibility.</strong> The safety and security of Your information, including Your Personal Data, also depends on You. You are responsible for maintaining confidentiality as to those credentials necessary to access the Platform. We ask that You not share Your credentials with any third-party Person.

                    </ol>

                    <ol>

                        c.      <strong>Internet Transmission.</strong> Unfortunately, the transmission of information via the Internet is not completely secure. Although We exercise best efforts to protect Your personal information, We cannot guarantee the security of Your information and data, including Your Personal Data, transmitted to or from the Platform. Any transmission of information and data, including Your Personal Data, is at Your own risk. Please exercise caution in submitting Your information and data, including Your Personal Data, especially if You are accessing the Platform using a Wi-Fi hotspot or public network. If You have reason to believe that Your use of or access to the Platform is no longer secure or protected, please immediately notify NPLF of the issue in accordance with the section titled “<strong>Comments, Concerns, and Complaints</strong>.”

                    </ol>
                    <p>
                    </p>
                    <ol>

                        d.    <strong>Limitation of Liability.</strong> EXCEPT AS OTHERWISE PROVIDED FOR IN THIS PRIVACY POLICY, NPLF EXPRESSLY DISCLAIMS ANY REPRESENTATION OR WARRANTY, WHETHER EXPRESS OR IMPLIED, WITH RESPECT TO ENSURING, GUARANTEEING, OR OTHERWISE OFFERING ANY DEFINITIVE REPRESENTATION OR WARRANTY OF SECURITY IN CONNECTION WITH YOUR INFORMATION AND DATA, INCLUDING YOUR PERSONAL DATA, OR USAGE INFORMATION, AND FURTHER DISCLAIMS ANY LIABILITY THAT MAY ARISE, SHOULD ANY OTHER THIRD-PARTY PERSONS OBTAIN THE INFORMATION YOU SUBMIT TO THE PLATFORM.

                    </ol>
                    <p>
                    </p>
                    VII.  <strong>  Third Parties and Third-Party Sites and Resources</strong>
                    <p>
                    </p>
                    <ol>
                        a.      <strong>Third-Party Sites and Resources</strong>. Our Platform, and its contents, resources, and services, may contain links to, or connections with, third-party sites and resources (“<strong>Third-Party Sites and Resources</strong>”) that are not operated, directly or indirectly, by NPLF. If You use or select any of the Third-Party Sites and Resources, You will be directed to the third party’s site. User acknowledges and agrees that NPLF has no control over and assumes no responsibility for the content, privacy policies, or practices of any Third-Party Sites and Resources.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        b.      <strong>Other Privacy Policies.</strong> To the extent that You submit, present, or offer any information or data, including Your Personal Data, to any third-party Person, such third-party Person’s collection, use, and disclosure of such information may be governed by its privacy policy, and not by Our Privacy Policy.
                    </ol>
                    <p>
                    </p>
                    <ol>
                        c.       <strong>Limitation of Liability.</strong> WE ARE NOT RESPONSIBLE FOR THE INFORMATION COLLECTION, USAGE, DISCLOSURE, OR OTHER PRIVACY PRACTICES OF ANY THIRD-PARTY PERSONS OR THIRD-PARTY SITES AND RESOURCES, INCLUDING OUR THIRD-PARTY SERVICE PROVIDERS, ANY THIRD-PARTY SOCIAL MEDIA PLATFORM (E.G., FACEBOOK, Instagram, X, or other), ANY THIRD-PARTY PERSON MAKING AVAILABLE THE DEVICES OR OPERATING SYSTEMS FOR WHICH CERTAIN WEBSITE RESOURCES, CONTENT, OR SERVICES ARE AVAILABLE (E.G., GOOGLE), AND ANY THIRD-PARTY PERSON OPERATING ANY SITE TO OR ON WHICH THE PLATFORM CONTAINS A LINK. THE INCLUSION OF A LINK ON THE PLATFORM DOES NOT IMPLY, DIRECTLY OR INDIRECTLY, ANY ENDORSEMENT OR SPONSORSHIP OF, OR RELATIONSHIP TO, THE LINKED SITE BY NPLF OR BY OUR AFFILIATES, SUCCESSORS, AND ASSIGNEES.
                    </ol>
                    <p>
                    </p>


                    VIII.<strong> General Provisions.</strong>
                    <p>
                    </p>
                    <ol>

                        a.       <strong>Terms of Use.</strong> Conditioned upon the use of and access to the Platform and its contents, services, and resources, NPLF mandates User to accept and agree to be bound by NPLF’s policy on its terms and conditions of use (“<strong>Terms of Use</strong>”), which is incorporated herein by reference at <a href="http://platform.beginbright.org/terms">platform.beginbright.org/terms</a>

                    </ol>
                    <p>
                    </p>
                    <ol>

                        b.      <strong>Do-Not-Track Technology.</strong> The Platform will continue to operate as described in this Privacy Policy, whether or not a “<strong>Do Not Track</strong>” signal or similar mechanism is received from Your web browser. We do not support Do Not Track (“<strong>DNT</strong>”) technology. You can enable or disable DNT by adjusting, altering, or changing the settings on the web browsers of Your preference.

                    </ol>
                    <p>
                    </p>
                    <ol>
                        c.       <strong>Comments, Concerns, and Complaints. </strong>All feedback, comments, request for technical support, and other communications relating to the Platform, the contents, resources, and services of the foregoing, and the privacy of Your data, including Personal Data, should be directed to the applicable agents and representatives via e-mail to: <a href="mailto:info@beginbright.org">info@beginbright.org</a>
                    </ol>
                    <p>
                    </p>
                    <p>
                        <em>Effective Date: July 1, 2025</em>
                    </p>

                </div>
            </div >

        </>

    );
};

export default PrivacyPolicy_en;
